import { render } from "./card-query.vue?vue&type=template&id=bb10b438&scoped=true"
import script from "./card-query.vue?vue&type=script&lang=js"
export * from "./card-query.vue?vue&type=script&lang=js"

import "./card-query.vue?vue&type=style&index=0&id=bb10b438&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_ZubV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb10b438"]])

export default __exports__